// @flow
import React, {PureComponent} from 'react';
import {Image, ScrollView, StyleSheet, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {EmphasizedSubText, Text} from 'trpc-react-native-ui';
import {FullButton} from '../../components/common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';

export default class ESimReplacement extends PureComponent<Props> {
  onPressOrderESim = () => {
    if (this.props.selectEsim) {
      this.props.selectEsim(true);
    }
    if (this.props.fetchEsimReference) {
      this.props.fetchEsimReference();
    }
    if (this.props.goToEsimCheck) {
      this.props.goToEsimCheck('eSimCheck', {
        simSwap: true,
        isOrderingReplacementSim: true,
      });
    }
  };

  render() {
    const styles = getStyles();

    if (
      !this.props.hasVisibleSubscriptions &&
      !this.props.hasSubscriptionToActivate
    ) {
      return (
        <View style={styles.emptyContainer}>
          <Image source={theme.terminationImage} style={styles.image} />
          <Text style={styles.emptyText}>
            {I18n.t('Dashboard.ESimReplacement.noSimToReplace')}
          </Text>
        </View>
      );
    }

    return (
      <SafeAreaView style={styles.safeareaview} edges={['bottom', 'left', 'right']}>
        <View style={styles.container}>
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <Image source={theme.eSimSwapImage} style={styles.eSimImage} />

            <View style={styles.bulletPointsContainer}>
              <EmphasizedSubText
                style={styles.enableESimText}
                emphStyle={styles.adviseEmphasis}
                text={I18n.t('Dashboard.ESimReplacement.enableESim')}
              />

              <EmphasizedSubText
                style={styles.lostESimText}
                emphStyle={styles.adviseEmphasis}
                text={I18n.t('Dashboard.ESimReplacement.simLost')}
              />
            </View>
          </ScrollView>
          <View style={styles.bottomPanel}>
            <FullButton
              style={{marginHorizontal: 10}}
              text={I18n.t('Dashboard.ESimReplacement.order')}
              onPress={this.onPressOrderESim}
              isLoading={this.props.isLoading}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

type Props = DispatchProps & StateProps;

export type DispatchProps = {
  goToEsimCheck: Function,
  selectEsim: Function,
  fetchEsimReference: Function,
};

export type StateProps = {
  isLoading: boolean,
  hasVisibleSubscriptions: boolean,
  hasSubscriptionToActivate: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    container: {
      flex: 1,
    },
    contentContainer: {
      alignItems: 'center',
      margin: 15,
    },
    bulletPointsContainer: {
      flex: 1,
      marginBottom: 15,
      marginTop: 20,
    },
    adviseEmphasis: {
      fontWeight: 'bold',
      textAlign: 'center',
    },
    enableESimText: {
      fontSize: 16,
      textAlign: 'center',
      marginHorizontal: 20,
      fontWeight: '600',
    },
    lostESimText: {
      fontSize: 16,
      textAlign: 'center',
      marginTop: 30,
      marginHorizontal: 20,
    },
    needReplacementSim: {
      fontSize: 22,
      textAlign: 'center',
      marginBottom: 30,
    },
    bulletPointContainerStyle: {
      alignItems: 'flex-start',
      marginLeft: 20,
    },
    bulletPointStyle: {
      color: theme.defaultTextColor,
      marginTop: 7,
      fontSize: 12,
    },
    bulletPointTextStyle: {
      fontSize: 18,
      paddingRight: 30,
    },
    eSimImage: {
      width: 190,
      height: 170,
      marginTop: 16,
      marginBottom: 29,
    },
    bottomPanel: {
      paddingBottom: 20,
      paddingHorizontal: 20,
      justifyContent: 'center',
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      textAlign: 'center',
      color: theme.emptyTextColor,
      fontSize: 16,
    },
    image: {
      width: 100,
      height: 100,
      marginTop: 40,
      marginBottom: 40,
      resizeMode: 'contain',
    },
  });
